import {Badge, Button, Col, Modal, Row} from "react-bootstrap";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import DateHelper from "../../../../primer/DateHelper/DateHelper";
import DateBox from "../../../../primer/DateBox";
import Input from "../../../../common/Input";
import axios from "axios";
import {toast} from "react-toastify";
import {getDocumentLabel} from "../../../../../_helpers/commonFunctions";
import {formatDeliveryStatus, formatDeliveryStatusColor, transferStatusOptions} from "./constants";
import Dropdown from "../../../../primer/Dropdown";
import {useTranslation} from "../../../../../hooks/useTranslation";

const SelectFromSalesModal = ({show, setShow, invoicesTable, callbackFunction}) => {
    const {t} = useTranslation();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);
    const [page, setPage] = useState(1);
    const [requestData, setRequestData] = useState({
        dateFrom: moment(String(company.year), "YYYY").startOf("year").format("DD/MM/YYYY"),
        dateTo: moment(String(company.year), "YYYY").endOf("year").format("DD/MM/YYYY"),
        myDataStatus: [],
    })
    const [viewData, setViewData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [selectedTransfers, setSelectedTransfers] = useState([]);

    const onAccept = () => {
        callbackFunction(selectedTransfers);
        setSelectedTransfers([]);
    }

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchViewData(true);
        }
    }, [pageChanged])

    useEffect(() => {
        if (show) {
            fetchViewData(true);
        }
    }, [show]);

    const fetchViewData = (fromPagination = true) => {
        setLoading(true);
        const toReq = {
            company: company.id,
            year: company.year,
            page: page,
            ...requestData,
        }
        if (!fromPagination) {
            setPage(1);
            toReq.page = 1;
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/get-transfers-by-sales`, {
            ...toReq,
        }, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data.status === "200") {
                setViewData(res.data.data.data);
                setTotalPages(res.data.data.totalPages);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const isSelected = (transfer) => {
        return selectedTransfers.some((el) => String(el.invoiceMark) === String(transfer.invoiceMark));
    }

    const isAlreadySelected = (transfer) => {
        return invoicesTable.some((el) => String(el.invoiceMark) === String(transfer.invoiceMark));
    }

    const handleSelect = (transfer) => {
        setSelectedTransfers([...selectedTransfers, transfer]);
    }

    const handleDeselect = (transfer) => {
        setSelectedTransfers(selectedTransfers.filter((el) => String(el.invoiceMark) !== String(transfer.invoiceMark)));
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal65PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Επιλογή Πωλήσεων Δ.Α. προς μεταφορά στον πίνακα Διακίνησεων</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"text-muted"}><i>Φίλτρα</i></div>
                <Row>
                    <Col md={3}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => setRequestData({...requestData, dateFrom: from, dateTo: to})}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name={"dateFrom"}
                            label={"Ημερομηνία από"}
                            selected={moment(requestData.dateFrom, "DD/MM/YYYY").isValid() ? moment(requestData.dateFrom, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => {
                                if (moment(e).isValid()) {
                                    setRequestData({...requestData, dateFrom: moment(e).format("DD/MM/YYYY")});
                                } else {
                                    setRequestData({...requestData, dateFrom: moment().format("DD/MM/YYYY")});
                                }
                            }}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name={"dateTo"}
                            label={"Ημερομηνία έως"}
                            selected={moment(requestData.dateTo, "DD/MM/YYYY").isValid() ? moment(requestData.dateTo, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => {
                                if (moment(e).isValid()) {
                                    setRequestData({...requestData, dateTo: moment(e).format("DD/MM/YYYY")});
                                } else {
                                    setRequestData({...requestData, dateTo: moment().format("DD/MM/YYYY")});
                                }
                            }}
                        />
                    </Col>
                    <Col md={5}>
                        <Input
                            name={"generalFilter"}
                            label={"Φίλτρο"}
                            value={requestData.generalFilter}
                            placeholder={"Φιλτάρισμα ΑΦΜ/Οντότητα"}
                            onChange={(e) => setRequestData({...requestData, generalFilter: e.target.value})}
                        />
                    </Col>
                </Row>
                <Row className={"mt-1"}>
                    <Col md={7}>
                        <Dropdown
                            name={"myDataStatus"}
                            label={"Κατάσταση Διακίνησης"}
                            options={transferStatusOptions}
                            multiSelect={true}
                            key={Math.random()}
                            defaultValue={transferStatusOptions.filter((el) => requestData.myDataStatus.includes(el.value))}
                            onChange={(e) => setRequestData({...requestData, myDataStatus: e.map((o) => o.value)})}
                        />
                    </Col>
                    <Col md={5} className={"d-flex justify-content-end"}>
                        <Button style={{marginTop: "35px"}} onClick={() => fetchViewData(false)}>Εφαρμογή φίλτρων</Button>
                    </Col>
                </Row>
                {totalPages > 0 && (
                    <React.Fragment>
                        <div className="d-flex justify-content-end mb-2 mt-2">
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => {
                                    setPage(1);
                                    setPageChanged(true);
                                }}
                                disabled={page === 1 || loading}
                            >
                                {t('SalesBalanceSheet.first')}
                            </Button>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => {
                                    setPage(page - 1);
                                    setPageChanged(true);
                                }}
                                disabled={page === 1 || loading}
                            >
                                {t('SalesBalanceSheet.previous')}
                            </Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1" bg="primary">{t('SalesBalanceSheet.page')} {page} / {totalPages}</Badge>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => {
                                    setPage(page + 1);
                                    setPageChanged(true);
                                }}
                                disabled={page === totalPages || loading}
                            >
                                {t('SalesBalanceSheet.next')}
                            </Button>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => {
                                    setPage(totalPages);
                                    setPageChanged(true);
                                }}
                                disabled={page === totalPages || loading}
                            >
                                {t('SalesBalanceSheet.last')}
                            </Button>
                        </div>
                        {viewData.length > 0 ? (
                            <table className={"simpleClassicTable"} style={{wordBreak: "break-all"}}>
                                <colgroup>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "25%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Ημερομηνία</th>
                                    <th>Στοιχεία εγγράφου</th>
                                    <th>Οντότητα</th>
                                    <th>Κατάσταση Διακίνησης</th>
                                    <th>Επιλογή</th>
                                </tr>
                                </thead>
                                <tbody>
                                {viewData.map((row, idx) => (
                                    <tr key={`ertable-${idx}`} style={{backgroundColor: (isSelected(row.transfer) || isAlreadySelected(row.transfer)) ? "lightgray" : ""}}>
                                        <td>{moment(row["date"]).format("DD/MM/YYYY")}</td>
                                        <td>{getDocumentLabel(row)}</td>
                                        <td>{row["clientName"]} - {row["vat"]}</td>
                                        <td style={{
                                            backgroundColor: formatDeliveryStatusColor(row.transfer.myDataStatus)
                                        }}>{formatDeliveryStatus(row.transfer.myDataStatus)}</td>
                                        <td>
                                            {isAlreadySelected(row.transfer) ? (
                                                <Badge bg={"dark"}>Ήδη υπάρχων</Badge>
                                            ) : isSelected(row.transfer) ? (
                                                <Badge bg={"danger"} style={{cursor: "pointer"}}
                                                       onClick={() => handleDeselect(row.transfer)}>Αποεπιλογή</Badge>
                                            ) : (
                                                <Badge bg={"primary"} style={{cursor: "pointer"}}
                                                       onClick={() => handleSelect(row.transfer)}>Επιλογή</Badge>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        ) : (
                            <span>Δεν βρέθηκαν δεδομένα</span>
                        )}
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onAccept()}>
                    Μεταφορά στον πίνακα
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SelectFromSalesModal;
